const isDev = process.env.REACT_APP_STAGE === 'development';
const isProd = process.env.REACT_APP_STAGE === 'production';
const isLocal = process.env.REACT_APP_STAGE === 'local';

export { isDev, isProd, isLocal };
